import { render, staticRenderFns } from "./FalcutySection.vue?vue&type=template&id=0506d2ca"
import script from "./FalcutySection.vue?vue&type=script&lang=js"
export * from "./FalcutySection.vue?vue&type=script&lang=js"
import style0 from "./FalcutySection.vue?vue&type=style&index=0&id=0506d2ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Section: require('/app/nuxt/components/Section.vue').default})
